/**
 * VersionChecker
 */
import React from 'react';
import { connect } from 'react-redux';

// Actions
import {
    requestPollingVersion,
    failedPollingVersion
} from '../../../../services/version/actions';

interface Props {
    requestPollingVersion: Function;
    failedPollingVersion: Function;
}

export class VersionChecker extends React.PureComponent<Props> {
    componentDidMount() {
        this.props.requestPollingVersion();
    }

    componentWillUnmount() {
        this.props.failedPollingVersion();
    }

    render() {
        return null;
    }
}

export default connect(
    null,
    { requestPollingVersion, failedPollingVersion }
)(VersionChecker);
